/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { AccessActionDto } from '../models/AccessActionDto';
import type { CreateAccessRequestDto } from '../models/CreateAccessRequestDto';
import type { CreateUserInvitationDto } from '../models/CreateUserInvitationDto';
import type { ReasonDto } from '../models/ReasonDto';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class AccessRequestService {
    constructor(public readonly http: HttpClient) {}
    /**
     * @param guid
     * @param requestBody
     * @returns binary
     * @throws ApiError
     */
    public accessRequestCreateAccessRequest(
        guid: string,
        requestBody: CreateAccessRequestDto,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/access/createrequest/{guid}',
            path: {
                'guid': guid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns binary
     * @throws ApiError
     */
    public accessRequestCreateAdminAccessRequest(
        requestBody: CreateAccessRequestDto,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/access/create/sso',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param siteId
     * @returns binary
     * @throws ApiError
     */
    public accessRequestGetBySiteId(
        siteId: number,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/access/{siteId}',
            path: {
                'siteId': siteId,
            },
        });
    }
    /**
     * @param accessRequestId
     * @param requestBody
     * @returns binary
     * @throws ApiError
     */
    public accessRequestGrantAccess(
        accessRequestId: number,
        requestBody: AccessActionDto,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/access/grant/{accessRequestId}',
            path: {
                'accessRequestId': accessRequestId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param accessRequestId
     * @param requestBody
     * @returns binary
     * @throws ApiError
     */
    public accessRequestRejectAccess(
        accessRequestId: number,
        requestBody: AccessActionDto,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/access/reject/{accessRequestId}',
            path: {
                'accessRequestId': accessRequestId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param siteId
     * @param userId
     * @param requestBody
     * @returns binary
     * @throws ApiError
     */
    public accessRequestRevokeAccessGrant(
        siteId: number,
        userId: number,
        requestBody: ReasonDto,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/access/revoke/{siteId}/{userId}',
            path: {
                'siteId': siteId,
                'userId': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @param isSiteDetails
     * @returns binary
     * @throws ApiError
     */
    public accessRequestSendInvitation(
        requestBody: CreateUserInvitationDto,
        isSiteDetails?: boolean,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/access/invite',
            query: {
                'isSiteDetails': isSiteDetails,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param invitationGuid
     * @param requestBody
     * @returns binary
     * @throws ApiError
     */
    public accessRequestReInvite(
        invitationGuid: string,
        requestBody: ReasonDto,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/access/reinvite/{invitationGuid}',
            path: {
                'invitationGuid': invitationGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param invitationGuid
     * @param requestBody
     * @returns binary
     * @throws ApiError
     */
    public accessRequestRevokeInvitation(
        invitationGuid: string,
        requestBody: ReasonDto,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/access/invitation/revoke/{invitationGuid}',
            path: {
                'invitationGuid': invitationGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param guid
     * @returns binary
     * @throws ApiError
     */
    public accessRequestGetInvitation(
        guid: string,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/access/invitation/{guid}',
            path: {
                'guid': guid,
            },
        });
    }
    /**
     * @param siteId
     * @returns binary
     * @throws ApiError
     */
    public accessRequestGetInvitationsBySiteId(
        siteId: number,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/access/invitations/{siteId}',
            path: {
                'siteId': siteId,
            },
        });
    }
    /**
     * @param guid
     * @returns binary
     * @throws ApiError
     */
    public accessRequestCheckIfUserExistByGuid(
        guid: string,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/access/ifUserExist/{guid}',
            path: {
                'guid': guid,
            },
        });
    }
}
